import { verifyLogin } from "axios/authentication/authenticationApi";
import {
  FETCH_USER_DETAILS_FAILED,
  FETCH_USER_DETAILS_STARTED,
  FETCH_USER_DETAILS_SUCCESS
} from "store/actions";
import { parseJwt } from "utils/utilFunctions";

const fetchUserDetailsSuccess = ({ token, userInfo, isRegistration = false }) => ({
  type: FETCH_USER_DETAILS_SUCCESS,
  payload: {
    token,
    userInfo,
    isNewUser: isRegistration
  },
});

const fetchUserDetailsStarted = () => ({
  type: FETCH_USER_DETAILS_STARTED,
});

const fetchUserDetailsFailed = (error) => ({
  type: FETCH_USER_DETAILS_FAILED,
  payload: {
    error,
  },
});


export const fetchUserDetails = ({ email, password, isRegistration }) => {
  return (dispatch) => {
    dispatch(fetchUserDetailsStarted());
    verifyLogin({ email, password })
      .then((res) => {
        const token = res.data?.token || null;
        const userInfo = parseJwt(res.data?.token) || null;
        dispatch(fetchUserDetailsSuccess({ token, userInfo, isRegistration }));
      })
      .catch((err) => {
        dispatch(
          fetchUserDetailsFailed(
            err.response?.data?.message || "Something went wrong!"
          )
        );
      });
  };
};